import moment from 'moment';
<template>
  <div class="login">
    <!-- <vue-particles
      color="#0a5571"
      :particleOpacity="0.7"
      :particlesNumber="80"
      shapeType="circle"
      :particleSize="4"
      linesColor="#0a5571"
      :linesWidth="1"
      :lineLinked="true"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="3"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="false"
      style="width: 100vw; height: 100vh"
    ></vue-particles> -->
    <div class="content">
      <p></p>
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item>
          <a-input
            :placeholder="$tc('lang.Login.Please_Number_mail')"
            size="large"
            v-decorator="[
              'name',
              {
                rules: [
                  {
                    required: true,
                    message: $tc('lang.Login.Please_Number_mail'),
                  },
                ],
              },
            ]"
          >
            <a-icon
              slot="prefix"
              type="user"
              style="color: rgba(0, 0, 0, 0.25)"
            />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input
            size="large"
            type="password"
            :placeholder="$tc('lang.Login.Please_input_your_password')"
            v-decorator="[
              'passWord',
              {
                rules: [
                  {
                    required: true,
                    message: $tc('lang.Login.Please_input_your_password'),
                  },
                ],
              },
            ]"
          >
            <a-icon
              slot="prefix"
              type="lock"
              style="color: rgba(0, 0, 0, 0.25)"
            />
          </a-input>
        </a-form-item>

        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            size="large"
            class="button-pri"
          >
            {{ $tc('lang.Login.Log_in') }}
          </a-button>
        </a-form-item>
      </a-form>
      <div class="bottom">
        <router-link to="/register">{{
          $tc('lang.Login.Sign_up')
        }}</router-link>
        <router-link to="/forgetPassword">{{
          $tc('lang.Login.Forget_password')
        }}</router-link>
        <router-link to="/home">{{ $tc('lang.Login.Home_page') }}</router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      checked: false,
    };
  },
  
  created(){
// 获取国际化sessionStorage信息
if (sessionStorage.getItem('lang') !== null) {
      this.$i18n.locale = JSON.parse(sessionStorage.getItem('lang')) || '';
    }
    console.log(this.$i18n.locale)
  },
  methods: {
    onChange(e) {
      const { checked } = e.target;
      this.checked = checked;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$http
            .post('/hzwmj/person/login', {
              loginUser: values.name,
              loginPass: values.passWord,
              personType: 'web',
            })
            .then((data) => {
              console.log('======', data);
              if (data.data.loginMessage === '登录成功') {
                this.$message.success('登录成功');
                // this.$cookie.set('token', data.token);
                this.$cookie.set('token', data.data.token);
                // this.$cookie.set('userId', data.data.person.id);
                sessionStorage.setItem(
                  'token',
                  JSON.stringify(data.data.token || ''),
                );
                sessionStorage.setItem(
                  'user',
                  JSON.stringify(data.data.person || ''),
                );
                sessionStorage.setItem(
                  'userServiceId',
                  JSON.stringify(data.data.userServiceId || ''),
                );
                // var number = sessionStorage.getItem("permissions").indexOf(key);

                this.$router.push({
                  path: '/',
                });
              } else {
                this.$message.error(data.data.loginMessage);
              }
            })
            .catch(() => {
              this.$message.error(this.$tc('lang.Login.err_text'));
            });
        }
      });
    },
  },
};
</script>

<style lang="less">
.login {
  height: 100vh;
  background-image: url(./image/banner3.png);
  background-repeat: no-repeat;
  background-size: 100vw 100vh;
  font-size: 16px;
  .content {
    width: 420px;
    height: 300px;
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 10px;
    bottom: 0;
    left: 0;
    margin: auto;
    padding: 20px 50px 40px;
    background-color: rgba(255, 255, 255, 0.4);
  }
  .ant-form-explain {
    text-align: left;
  }
  p {
    font-size: 20px;
    color: rgba(255, 255, 255, 0.8);
    margin: 25px 0;
    text-align: center;
  }
  .button-pri {
    width: 100%;
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    a {
      color: rgba(255, 255, 255, 0.8);
    }
  }
}
</style>
